import * as yup from 'yup';
import { stringValidation } from './stringValidation';

stringValidation(yup);

export { yup };
